import React from "react";
import LogoutDropdown from "./Logout";
import CustomTooltip from "../Common/CustomTooltip";
import { NavLink } from "react-router-dom";
import { Button } from "react-bootstrap";

const Header = ({
  title,
  tooltipContent,
  tooltipPlacement,
  infoTooltip,
  tooltipContentTwo,
  tooltipContentThree,
  tooltipContentFour,
  showLedgerBtn = false,
  ledgerUrl = "",
  showBackBtn = false,
  backUrl = "",
}) => {
  return (
    <div className="header">
      <div className="title d-flex gap-2">
        {showBackBtn && (
          <NavLink to={backUrl}>
            <Button variant="light" className="p-2 border">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-left-icon lucide-chevron-left"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </Button>
          </NavLink>
        )}
        <div className="d-flex flex-rows align-items-center gap-2">
          {title}

          {showLedgerBtn && ledgerUrl && (
            <NavLink to={ledgerUrl} target="_blank">
              <span className="blockchain-ledger-wiz btn btn-outline-primary">
                TrustGrid Ledger
              </span>
            </NavLink>
          )}

          <CustomTooltip
            content={tooltipContent}
            contentTwo={tooltipContentTwo}
            contentThree={tooltipContentThree}
            contentFour={tooltipContentFour}
            placement={tooltipPlacement}
            infoTooltip={infoTooltip}
          />
        </div>
      </div>
      <div className="welcome-user">
        <LogoutDropdown />
      </div>
    </div>
  );
};

export default Header;
